<template>
  <p class="raw-heading-3">
    <InlineMarkdown :message="fact.text" /><SourceMarker
      :refs="fact.sourceRefs"
      :zone
    />
  </p>
</template>

<script setup lang="ts">
import InlineMarkdown from '~/scopes/campaign/components/UI/InlineMarkdown.vue'
import SourceMarker from '~/scopes/campaign/components/UI/SourceMarker.vue'
import type { MetalBlock } from '~/scopes/campaign/data/metals/types'

// Through `InlineMarkdown` so the hero statement can end on a `[^*]` footnote marker, which
// is where the client puts it on cobalt ("…as young as 6.*") and tin.
defineProps<{
  fact: MetalBlock
  /** Tracking surface of the host view, forwarded to the fact's citation. */
  zone: string
}>()
</script>
